import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { ADMIN_NAV } from "./_nav";
import { api, errFrom } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Button } from "../../components/ui/button";
import MultiImageCard from "../../components/MultiImageCard";
import { toast } from "sonner";
import { Filter, Calendar } from "lucide-react";

export default function AdminInspections() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ customer_name: "", inspection_type: "", start: "", end: "" });

  async function load() {
    try {
      const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
      const { data } = await api.get("/admin/customer-inspections", { params });
      setItems(data);
    } catch (e) { toast.error(errFrom(e)); }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <AppShell nav={ADMIN_NAV} title="Customer Cars" subtitle="Pre / Post inspections">
      <div className="brand-surface rounded-2xl p-5 mb-6">
        <div className="flex items-center gap-2 mb-4 text-overline"><Filter size={12} />Filters</div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          <div className="md:col-span-2"><Label className="text-[10px] uppercase text-zinc-500">Customer name</Label><Input className="h-10 bg-[#0A0A0A] border-white/10 mt-1" value={f.customer_name} onChange={(e) => setF({ ...f, customer_name: e.target.value })} placeholder="Search…" data-testid="filter-customer" /></div>
          <div>
            <Label className="text-[10px] uppercase text-zinc-500">Type</Label>
            <Select value={f.inspection_type || "__all"} onValueChange={(v) => setF({ ...f, inspection_type: v === "__all" ? "" : v })}>
              <SelectTrigger className="h-10 bg-[#0A0A0A] border-white/10 mt-1"><SelectValue placeholder="Any" /></SelectTrigger>
              <SelectContent className="bg-[#141414] border-white/10 text-white">
                <SelectItem value="__all">All</SelectItem>
                <SelectItem value="pre">Pre</SelectItem>
                <SelectItem value="post">Post</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label className="text-[10px] uppercase text-zinc-500">Start</Label><Input type="date" className="h-10 bg-[#0A0A0A] border-white/10 mt-1" onChange={(e) => setF({ ...f, start: e.target.value ? new Date(e.target.value).toISOString() : "" })} /></div>
          <div><Label className="text-[10px] uppercase text-zinc-500">End</Label><Input type="date" className="h-10 bg-[#0A0A0A] border-white/10 mt-1" onChange={(e) => setF({ ...f, end: e.target.value ? new Date(e.target.value + "T23:59:59").toISOString() : "" })} /></div>
        </div>
        <div className="mt-4 flex gap-2">
          <Button onClick={load} className="bg-[#FF3B30] hover:bg-[#E02920] h-10" data-testid="apply-inspection-filters">Apply</Button>
          <div className="ml-auto text-xs text-zinc-500 self-center">{items.length} results</div>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="brand-surface rounded-2xl p-12 text-center text-zinc-500">No inspections yet.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((i) => (
            <MultiImageCard key={i.id} item={i} testId={`inspection-card-${i.id}`}>
              <div className="text-sm font-semibold truncate">{i.customer_name}</div>
              <div className="text-xs text-zinc-500 truncate">by {i.user_name}</div>
              <div className="flex items-center gap-1 text-[11px] text-zinc-500 mt-1"><Calendar size={10} />{new Date(i.created_at).toLocaleString()}</div>
            </MultiImageCard>
          ))}
        </div>
      )}
    </AppShell>
  );
}
